interface Props {
  first: number
  total?: number
  afterClick?: (position: number) => void
}

const useNavigationSlider = ({ first, total, afterClick }: Props) => {
  const goToNextPosition = (current: number) => {
    const next = current + 1
    afterClick?.(next)
  }

  const goToPreviousPosition = (current: number) => {
    const previous = current - 1
    afterClick?.(previous)
  }

  const gotoEndPosition = () => {
    typeof total === 'number' && afterClick?.(total)
  }

  const gotoStartPosition = () => {
    afterClick?.(first)
  }

  return {
    goToNextPosition,
    goToPreviousPosition,
    gotoStartPosition,
    gotoEndPosition
  }
}

export default useNavigationSlider
